import * as React from 'react';

interface Props {
  highlightStartPercentage: number;
  highlightEndPercentage: number;
}

function BumpBarGraphic(props: Props) {
  const highlightWidth = props.highlightEndPercentage - props.highlightStartPercentage;

  return (
    <svg
      width="200px"
      height="20px"
      viewBox="0 0 100 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask id="mask" fill="white">
        <polygon points="100 0 100 10 1.71303943e-13 10 0 9.5" />
      </mask>
      <rect
        className="bump-bar-graphic__background"
        fillRule="nonzero"
        mask="url(#mask)"
        x="0"
        y="0"
        width="100"
        height="10"
      />
      <rect
        className="bump-bar-graphic__highlight"
        fillRule="nonzero"
        mask="url(#mask)"
        x={props.highlightStartPercentage}
        y="0"
        width={highlightWidth}
        height="10"
      />
    </svg>
  );
}

export default BumpBarGraphic;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_bar_graphic.tsx